<template>
  <!-- Renderless 组件：管理 AI 解读要素图层 -->
</template>

<script setup>
import {
  onMounted, onUnmounted,
  computed, ref, reactive, toRaw,
  h, defineComponent,
} from 'vue';
import store from '@/store';
import { ElScrollbar } from 'element-plus';
import { marked } from 'marked';
import { vueCreateAppInit } from '@/utils/js/initVariable';
import { dragPopupComCreate } from '@/utils/js/leaflet/dragPopup.js';
import { queryOtherDataByMap } from '@/api/UserWorkspaceDataApi';
import EditPopup from '@/views/Home/component/ManagePanel/components/WorkSpace/components/WorkSpaceData/components/CustomLocaleControl/components/EditPopup';

const props = defineProps({
  mapId: { type: [String, Number], required: true },
});

const homeMap = computed(() => store.getters['getHomeMap']),
  map = toRaw(homeMap.value),
  layerGroup = L.featureGroup().addTo(map);

// AI 解读弹窗渲染
const analysisResultGroupCreate = (data) => {
  if (!data) return;
  const resultGroup = L.featureGroup();

  data.forEach(target => {
    let zoomClose, zoomCloseFn = () => {
      zoomClose && zoomClose();
      zoomClose = undefined;
    };
    const latlng = target['startPoint'] && L.latLng(target['startPoint'].split(',')),
      endLatlng = target['endPoint'] && L.latLng(target['endPoint'].split(',')),
      zoom = target['zoomlevel'],
      analysisResult = target['analysisResult'];

    const { app, zoomFn, group } = dragPopupComCreate(latlng, {}, {
      endLatlng, zoom, lineShow: false,
    })(
      defineComponent({
        setup() {
          const opacity = ref(0.6);
          return () => h(EditPopup, {
            controls: [
              reactive({
                iconName: 'close-box', fill: 'rgb(6, 180, 221)',
                onClick: () => { closeFn(); },
              })
            ],
            style: { opacity: opacity.value },
            onMouseover: () => { opacity.value = 1; },
            onMouseout: () => { opacity.value = 0.6; },
          },
            () => h(ElScrollbar, {
              maxHeight: 200,
              wrapStyle: { width: '200px' },
              onWheel: (e) => { e.stopPropagation && e.stopPropagation(); }
            }, {
              default: () => h('div', {
                className: 'marked-change-content',
                innerHTML: marked(analysisResult),
              })
            })
          )
        }
      })
    );

    group.once({
      add: event => {
        if (zoom) { zoomClose = zoomFn(map); }
      },
      remove: event => { closeFn(); }
    });

    const closeFn = () => {
      zoomCloseFn();
      app && app.unmount && app.unmount();
      group && resultGroup.removeLayer(group);
    };

    resultGroup.addLayer(group);
  });
  return resultGroup;
};

// 数据管理
let analysisResultMap = new Map();
const analysisResultMapSet = (id, group) => {
  analysisResultMapDel(id);
  group && layerGroup.addLayer(group);
  analysisResultMap.set(id, group);
};
const analysisResultMapDel = (id) => {
  if (!analysisResultMap.has(id)) return;
  const group = analysisResultMap.get(id);
  group && layerGroup.removeLayer(group);
  analysisResultMap.delete(id);
};

// 请求数据
const queryOtherDataByMapFn = (id) => {
  queryOtherDataByMap(id).then(res => {
    if (res.data.code == 1004) {
      const group = analysisResultGroupCreate(res.data.data);
      analysisResultMapSet(id, group);
    }
  }).catch(err => {
    console.log(err);
  });
};

onMounted(() => {
  queryOtherDataByMapFn(props.mapId);
});

onUnmounted(() => {
  analysisResultMap.forEach((group) => {
    group && layerGroup.removeLayer(group);
  });
  analysisResultMap.clear();
  map.removeLayer(layerGroup);
});
</script>
